const iconDetail = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M15 1v14H1V1zm-6 9.5H2.5v3H9zm4.5-8h-3v11h3zM9 6.5H2.5V9H9zm0-4H2.5V5H9z"/></svg>',
};

export { iconDetail as default };
